import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import type { SensorResource } from '~/client/src/shared/resources/domain/sensorResource'
import type { SensorResourceDomainFailure } from '~/client/src/shared/resources/domain/sensorResourceTypeDefinition'
import { requireSensorResourceSuccess } from '~/client/src/shared/resources/presentation/requireSensorResourceSuccess'
import type ProjectResourcesStore from '~/client/src/shared/stores/domain/ProjectResources.store'

import {
  ProjectResourceStoreView,
  useProjectResourceStore,
} from './useProjectResourceStore'

type SensorResourcesStore = ProjectResourcesStore<
  SensorResource,
  SensorResourceDomainFailure
>

interface SensorResourceStoreContext {
  readonly sensorResourcesStore: SensorResourcesStore
}

export type SensorResourceStoreView = ProjectResourceStoreView<
  SensorResource,
  SensorResourceDomainFailure
>

export function useSensorResourceStore(
  projectId?: string,
): SensorResourceStoreView {
  const { sensorResourcesStore } = React.useContext(
    MobXProviderContext,
  ) as SensorResourceStoreContext

  return useProjectResourceStore(
    projectId,
    sensorResourcesStore,
    requireSensorResourceSuccess,
  )
}
